// extracted by mini-css-extract-plugin
export var headerCell = "_3w-1";
export var loadingSpinnerContainer = "_3w-4";
export var rowWrapper = "_3w-3";
export var standaloneTable = "_3w-5";
export var table = "_3w-0";
export var white = "_3w-2";